import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Tip } from '../timeline-item.types';

@Component({
    selector: 'tm-tip-dialog',
    styleUrls: ['./tip-dialog.component.scss'],
    templateUrl: './tip-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogModule,
        TranslateModule
    ]
})
export class TipDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: TipDialogData) {
    }
}

export type TipDialogData = {
    tip: Tip
}